import memoize from 'fast-memoize';
import { CodingConstants } from '@constants';
import { MainMenuOptions, NavigationOptions } from '../types/widgets.types';
export const getmenuOptions = memoize((menuOptions: MainMenuOptions[], content: string, accountLoanType: string) => {
    const { servicingLoanType, inProgressLoanType, servicingType } = CodingConstants;
    const options: MainMenuOptions[] = [];
    const selectedLoanType = accountLoanType && accountLoanType !== '' ? accountLoanType : 'default';

    menuOptions?.forEach((ele: MainMenuOptions) => {
        if (ele.subMenuOptions) {
            const subMenuOptions: NavigationOptions[] = [];
            let checkIfSelectedLoanTypeMatchesSubMenuOptions = false;
            ele.subMenuOptions.map(opt => {
                if (opt.loanType === 'common' || opt.loanType === selectedLoanType) {
                    subMenuOptions.push(opt);
                    checkIfSelectedLoanTypeMatchesSubMenuOptions =
                        opt.loanType === selectedLoanType ? true : checkIfSelectedLoanTypeMatchesSubMenuOptions;
                }
            });
            if (!checkIfSelectedLoanTypeMatchesSubMenuOptions) {
                const index = ele.subMenuOptions.findIndex(e => e.loanType === 'default');
                if (index !== -1) {
                    subMenuOptions.push(ele.subMenuOptions[index]);
                }
            }

            if (content === servicingLoanType || content === inProgressLoanType) {
                options.push({ ...ele, subMenuOptions });
            } else {
                if (ele.menuType !== servicingType) {
                    const subOptionType = subMenuOptions.filter(ele => ele.menuType !== servicingType);
                    options.push({ ...ele, subMenuOptions: subOptionType });
                }
            }
        } else {
            options.push({ ...ele });
        }
    });
    return options;
});
